var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyAgenda = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227.059,
    height: 154.06,
    viewBox: "0 0 227.059 154.06",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f3f8;}.b{fill:#fff;}.c{fill:#e3f5ff;}.d{fill:none;}.e{fill:#5fc8ff;}.f{fill:#ffebe3;}.g{fill:#ff905f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-569 -307.69)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.523,33.2c14.739,29.09-.97,84.167-35.1,107.439S99.733,155.38,59.395,126.872C19.251,98.364-8.87,49.88,2.572,25.057,14.208.233,65.6-.737,113.7.233S206.978,4.306,221.523,33.2Z",
    transform: "translate(569 307.69)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.806 -4.149)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.11 312.322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H115.7a5,5,0,0,1,5,5V56.327a5,5,0,0,1-5,5H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 92.657,
    height: 6.99,
    rx: 3.495,
    transform: "translate(13.919 10.123)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 31.634,
    height: 6.99,
    rx: 3.495,
    transform: "translate(13.919 20.446)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 83.815,
    height: 3.495,
    rx: 1.748,
    transform: "translate(13.919 39.087)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32.553,
    height: 3.495,
    rx: 1.748,
    transform: "translate(13.919 46.078)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32.553,
    height: 3.495,
    rx: 1.748,
    transform: "translate(52.366 46.078)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.11 379.895)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H115.7a5,5,0,0,1,5,5V56.327a5,5,0,0,1-5,5H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 92.657,
    height: 6.99,
    rx: 3.495,
    transform: "translate(13.919 10.123)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 31.634,
    height: 6.99,
    rx: 3.495,
    transform: "translate(13.919 20.446)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 83.815,
    height: 3.495,
    rx: 1.748,
    transform: "translate(13.919 39.087)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32.553,
    height: 3.495,
    rx: 1.748,
    transform: "translate(13.919 46.078)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32.553,
    height: 3.495,
    rx: 1.748,
    transform: "translate(52.366 46.078)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(614.141 312.322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5,0H45.97a0,0,0,0,1,0,0V61.582a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.399 11.126)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.518)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H10.836V10.836H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M6.51,2a4.515,4.515,0,1,0,4.52,4.515A4.513,4.513,0,0,0,6.51,2Zm0,8.127a3.612,3.612,0,1,1,3.612-3.612A3.611,3.611,0,0,1,6.515,10.127Z",
    transform: "translate(-1.097 -1.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M11.677,7H11V9.709l2.37,1.422.339-.555L11.677,9.37Z",
    transform: "translate(-6.033 -3.84)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.314,
    height: 5.359,
    rx: 2.68,
    transform: "translate(0.227)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 14.158,
    height: 5.359,
    rx: 2.68,
    transform: "translate(0.227 8.155)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(614.141 379.895)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M5,0H45.97a0,0,0,0,1,0,0V61.582a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.399 11.126)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.518)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H10.836V10.836H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M6.51,2a4.515,4.515,0,1,0,4.52,4.515A4.513,4.513,0,0,0,6.51,2Zm0,8.127a3.612,3.612,0,1,1,3.612-3.612A3.611,3.611,0,0,1,6.515,10.127Z",
    transform: "translate(-1.097 -1.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M11.677,7H11V9.709l2.37,1.422.339-.555L11.677,9.37Z",
    transform: "translate(-6.033 -3.84)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 22.314,
    height: 5.359,
    rx: 2.68,
    transform: "translate(0.227)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 14.158,
    height: 5.359,
    rx: 2.68,
    transform: "translate(0.227 8.155)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyAgenda);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-agenda.631d5ca2ca438da8c6e6c8c29f7e6fe8.svg";